var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDirectorio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1000",
    "data-name": "Grupo 1000",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_210",
    "data-name": "Rect\\xE1ngulo 210",
    width: 45,
    height: 45,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mUiDKq.tif",
    transform: "translate(9.473 3.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_999",
    "data-name": "Grupo 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_469",
    "data-name": "Trazado 469",
    d: "M23.284,3.146a.793.793,0,0,1,.363.787c-.02.244,0,.491,0,.786H25.1c.35,0,.7,0,1.049,0,.624,0,.811.2.812.852s0,1.331,0,2.033h.43q3.021,0,6.042,0c.62,0,.777.156.777.779V40.437c0,.627-.157.786-.77.787H8.912c-.589,0-.751-.165-.751-.768V13.348a2.042,2.042,0,0,1,0-.26.523.523,0,0,1,.462-.494.5.5,0,0,1,.605.348,1.919,1.919,0,0,1,.063.585q0,12.978,0,25.955v.543H33.053V8.8H26.963c0,.526,0,1.044,0,1.561,0,.581-.2.793-.758.793q-5.211,0-10.42,0c-.568,0-.748-.2-.749-.785,0-.519,0-1.037,0-1.578H9.3c0,.5,0,1,0,1.487a1.752,1.752,0,0,1-.053.476.55.55,0,0,1-1.074-.128q-.021-1.245,0-2.491c0-.34.235-.529.612-.531.747-.006,1.495,0,2.243,0h4.014c0-.734,0-1.437,0-2.138,0-.537.2-.742.715-.746.711,0,1.42,0,2.178,0,0-.281.016-.539,0-.792a.755.755,0,0,1,.367-.782Zm2.5,6.828V5.915H16.2V9.974ZM22.464,4.706V4.336h-3.37v.371Z",
    transform: "translate(-8.157 -3.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_470",
    "data-name": "Trazado 470",
    d: "M23,26.494c-1.978,0-3.956-.014-5.932.01-.49.007-.839-.463-.591-.829a1.014,1.014,0,0,1,.426-.294.937.937,0,0,1,.358-.022q5.735,0,11.469,0a2,2,0,0,1,.43.033.513.513,0,0,1,.43.582.519.519,0,0,1-.511.514c-.12.01-.241.005-.362.005Z",
    transform: "translate(-7.334 -0.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_471",
    "data-name": "Trazado 471",
    d: "M22.984,15.338H17.3a3.211,3.211,0,0,1-.326-.005.593.593,0,0,1-.585-.608.567.567,0,0,1,.624-.519q5.97,0,11.938,0a.572.572,0,0,1,.641.541c.011.34-.254.586-.68.59-1.086.009-2.17,0-3.256,0Z",
    transform: "translate(-7.334 -1.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_472",
    "data-name": "Trazado 472",
    d: "M22.957,32.085q-2.944,0-5.889,0c-.277,0-.531-.067-.607-.344a.676.676,0,0,1,.075-.556.933.933,0,0,1,.6-.238c.867-.025,1.735-.01,2.6-.01h8.889c.085,0,.169,0,.253,0,.442.009.726.244.716.593s-.279.551-.709.552Q25.92,32.086,22.957,32.085Z",
    transform: "translate(-7.329 0.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_473",
    "data-name": "Trazado 473",
    d: "M15.71,15c0,.494.005.988,0,1.483a.6.6,0,0,1-.666.673q-1.462.007-2.926,0a.58.58,0,0,1-.646-.619q-.02-1.536,0-3.073a.569.569,0,0,1,.611-.618q1.5-.02,3,0a.582.582,0,0,1,.627.638C15.718,13.992,15.71,14.5,15.71,15Zm-1.162-.925H12.623v1.84h1.926Z",
    transform: "translate(-7.827 -1.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_474",
    "data-name": "Trazado 474",
    d: "M22.969,20.907H17.29c-.108,0-.217,0-.326,0a.567.567,0,0,1-.571-.537.574.574,0,0,1,.57-.579c.1-.009.193-.007.289-.007q5.734,0,11.466,0c.6,0,.879.179.88.564s-.274.562-.879.562Z",
    transform: "translate(-7.334 -0.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_475",
    "data-name": "Trazado 475",
    d: "M15.71,20.678c0,.482.005.964,0,1.445a.586.586,0,0,1-.637.665q-1.48.025-2.96,0a.585.585,0,0,1-.642-.663q-.015-1.462,0-2.926a.587.587,0,0,1,.657-.644q1.462-.008,2.924,0c.439,0,.653.224.659.675C15.716,19.715,15.71,20.2,15.71,20.678Zm-3.087.958h1.912V19.721H12.624Z",
    transform: "translate(-7.827 -1.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_476",
    "data-name": "Trazado 476",
    d: "M15.711,31.881c0,.47,0,.939,0,1.409s-.216.7-.673.707q-1.445.015-2.889,0c-.46-.006-.677-.233-.681-.7q-.01-1.427,0-2.854a.608.608,0,0,1,.693-.687q1.426-.007,2.852,0c.481,0,.692.225.7.718C15.713,30.941,15.711,31.411,15.711,31.881Zm-1.174.963V30.928H12.626v1.915Z",
    transform: "translate(-7.827 0.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_477",
    "data-name": "Trazado 477",
    d: "M13.6,28.349c-.494,0-.989,0-1.483,0a.574.574,0,0,1-.642-.619q-.021-1.483,0-2.969a.563.563,0,0,1,.629-.63q1.483-.015,2.967,0a.574.574,0,0,1,.642.653q.008,1.447,0,2.9a.589.589,0,0,1-.664.669C14.562,28.354,14.08,28.349,13.6,28.349Zm.938-1.161V25.281H12.625v1.907Z",
    transform: "translate(-7.827 -0.346)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirectorio);
export default __webpack_public_path__ + "static/media/ic_directorio.17e2763e95d868f355b4cd339d33d36a.svg";
export { ForwardRef as ReactComponent };